export default __webpack_public_path__ + "fonts/Roboto-500-latin21.woff2";